import React, { useEffect, useState } from 'react';
import Label from './fromLabel';
import Error from './fromError';
import Icon from '../../icons';


interface InputProps {
    type: 'text' | 'password' | 'email' | 'number' 
    placeholder?: string;
    value?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    label?: string;
    required?: boolean;
    info?:string;
    error?:string;
    className?: string;
    mainELclassName?: string;
    size?: 'sm' | 'md' | 'lg';
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    maxLength?: number;
}

const Input: React.FC<InputProps> = ({ type, placeholder, value, size = 'md', onChange, className = '', mainELclassName = ``, disabled = false, label, required, info, error, onKeyDown = (e: any) => { }, maxLength }) => {
    const [visible, setVisible] = useState<boolean>(false);
    return (
        
        <div className={`my-6 ${className}`}>
            {label && <Label text={label} required={required} info={info} />}
            <div className='relative'>
                <input
                onKeyDown={onKeyDown}
                type={visible ? 'text' : type}
                placeholder={placeholder}
                value={value != undefined ? value : ''}
                onChange={onChange}
                disabled={disabled}
                maxLength={maxLength}
                className={` ${error ? 'border-red-500 border-2' : 'border-[#CECECE] border'} rounded-md focus:outline-none  focus:primary ${size == 'sm'?'text-[0.667rem] mt-0 pl-2 py-1  font-normal h-[1.875rem]':'text-[0.938rem] mt-2 pl-4 py-2  font-normal h-[2.875rem]'} text-[#222222] placeholder:text-[#a1a1a1] w-full ${mainELclassName}`}
            />
            {type == 'password' && (
                <span
                    className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer mt-1"
                    onClick={() => setVisible((v) => !v)}
                >
                    <Icon className="" name={visible ? 'eye-closed' : 'eye'} size={1.2} />
                </span>
            )}
            </div>
            
            {error && <Error message={error} />}
        </div>
    );
};

export default Input;